import { connect } from 'react-redux';
import { push } from 'react-router-redux';

// Constants
import { exportTypes } from 'constants/values';

// Selectors
import {
  canChooseSeedProduct as canChooseSeedProductFunc,
  getActiveField,
  getActiveScript,
  getActiveScriptConfigView,
  getExportOptionsIsOpen,
  getSelectedZoneIds,
  isOverlaySelectModalActive as isOverlaySelectModalActiveFunc,
  shouldScrollToSelectedZone as shouldScrollToSelectedZoneFunc
} from 'current/selectors';
import {
  shouldShowLiquidApplication as shouldShowLiquidApplicationFunc,
  isSaveTriggerEnabled as isSaveTriggerEnabledFunc
} from 'current/uiwidgets/selectors';
import { canManualScript as canManualScriptFunc } from 'product-features/selectors';
import { isAppMode as isAppModeFunc } from 'settings/selectors';

// Action Creators
import {
  openConfirmModal,
  openQuitFlowModal,
  setEditScriptExitButtonBehavior,
  setExportOptionsIsOpen
} from 'current/uiwidgets/';
import { backToLandingPage } from 'scripts';
import { toggleEditLegendOnExit } from 'legends';

// Util
import setupEditUi from './setupEditUi';

import EditContainer from './EditContainer';
import { hasUnsavedUpdates, isCompleteScript } from '../scripts/selectors';

export default connect(
  (state) => {
    const script = getActiveScript(state);
    const zones = script && script.zones;
    const scriptId = script && script.id;
    const isAppMode = isAppModeFunc(state);
    const scriptLoadIsInProgress = !zones;
    const canManualScript = canManualScriptFunc(state);

    return zones ? {
      activeField: getActiveField(state),
      canChooseSeedProduct: canChooseSeedProductFunc(state),
      canManualScript,
      isSaveTriggerEnabled: isSaveTriggerEnabledFunc(state, script),
      exportOptionsIsOpen: getExportOptionsIsOpen(state),
      isAppMode,
      isExitButtonVisible: !isAppMode,
      isOverlaySelectModalActive: isOverlaySelectModalActiveFunc(state),
      scriptConfigView: getActiveScriptConfigView(state),
      scriptId,
      scriptLoadIsInProgress,
      selectedZoneIds: getSelectedZoneIds(state),
      shouldScrollToSelectedZone: shouldScrollToSelectedZoneFunc(state),
      showLiquidApplication: shouldShowLiquidApplicationFunc(state),
      script
    } : {
      canManualScript,
      scriptLoadIsInProgress,
      scriptId
    }; // if there's no script here, pass an undefined scriptId so the component knows not to render
  },
  (dispatch) => {
    return {
      onClickExportTrigger: () => dispatch(setExportOptionsIsOpen({ exportType: exportTypes.SINGLE, status: true })),
      onClickCancelTrigger: (script, redirectUrl) => {
        dispatch(toggleEditLegendOnExit());
        if (hasUnsavedUpdates(script) || !isCompleteScript(script)) {
          dispatch(openQuitFlowModal());
        } else {
          dispatch(backToLandingPage(redirectUrl));
        }
      },
      onClickSaveTrigger: (scriptId) => {
        dispatch(openConfirmModal(scriptId));
      },
      onMount: ({ canManualScript, isAppMode }) => {
        // They cannot deeplink into edit if they're not allowed to manual script
        if(!isAppMode && !canManualScript) {
          dispatch(push('/'));
        }

        dispatch(setupEditUi());

        dispatch(setEditScriptExitButtonBehavior());
      }
    };
  }
)(EditContainer);
